export default "__VITE_ASSET__264dfd0e__"